/**
 * 保険証に表示する氏名を取得する
 *
 * 基幹システムに登録されている名前は中間サーバーの文字数制約によりフルネームではないことがあります。
 * しかし、保険証に記載する氏名はフルネームの必要があるため、フルネームを名前に登録できなかった場合に限り、保険証氏名にフルネームが登録されています。
 */
export function getInsuranceCardDisplayName({
  insuranceCardName,
  name,
}: {
  insuranceCardName: string | null | undefined;
  name: string;
}): string {
  return insuranceCardName?.trim() || name;
}
